import Phone from './Phone';

export default Phone;
